export const BASE_URL = `${import.meta.env.VITE_BASE_URL}/api/v1`

// export const BASE_URL = `${import.meta.env.VITE_BASE_URLLocal}/api/v1`
